import { render, staticRenderFns } from "./addBiddingGoods.vue?vue&type=template&id=227c4132&scoped=true"
import script from "./addBiddingGoods.vue?vue&type=script&lang=js"
export * from "./addBiddingGoods.vue?vue&type=script&lang=js"
import style0 from "./addBiddingGoods.vue?vue&type=style&index=0&id=227c4132&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "227c4132",
  null
  
)

export default component.exports